import { configurationContextDefaultValues } from '@ori/favorites-context';
import type { AppDataConfiguration } from '@ori/favorites-context';

import { isValidProperty } from './isValidProperty';

/**
 * Takes a string and parses it as JSON. Throws error if resulting config does not have required keys
 * @param config config in JSON value
 * @param requiredProperties required properties from defined AppDataConfig type
 * @returns Type-safe parsed config value
 */
export function parseSpaConfig<T extends keyof AppDataConfiguration>(config: string, requiredProperties: T[] = []) {
  if (!config) {
    throw new Error('No config provided!');
  }

  const parsedConfig = JSON.parse(config) as Partial<AppDataConfiguration> & Required<Pick<AppDataConfiguration, T>>;

  requiredProperties.forEach((prop) => {
    if (!isValidProperty(parsedConfig, String(prop))) {
      throw new Error(`Missing ${String(prop)} config property!`);
    }
  });

  return {
    // We should set default values to stay true to typings
    customerId: configurationContextDefaultValues.customerId,
    ...parsedConfig,
  };
}
